import { render, staticRenderFns } from "./TransferAndLegInformation.vue?vue&type=template&id=6bf6ca82&scoped=true"
import script from "./TransferAndLegInformation.vue?vue&type=script&lang=js"
export * from "./TransferAndLegInformation.vue?vue&type=script&lang=js"
import style0 from "./TransferAndLegInformation.vue?vue&type=style&index=0&id=6bf6ca82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf6ca82",
  null
  
)

export default component.exports